export const contactsData = {
    email: 'khashayar.kazemi.info@gmail.com',
    phone: '+43 664 1476069',
    address: 'Vienna, Austria',
}
